'use strict';

import * as Formsy from 'formsy-react';
import utils from 'services/utils';
import moment from 'moment';

import constants from 'constants/appConstants';

Formsy.addValidationRule('conditionalDependency', function (values, value, otherField) {
    if (!values[otherField]) {
        return true;
    }
    return value !== undefined && value.length !== 0 ? true : false;
});

Formsy.addValidationRule('hasMaxLength', function (values, value) {
    if (!value) {
        return true;
    } else {
        return value.length < 8;
    }
});

Formsy.addValidationRule('includeAtLeastOne', function (values, value, otherField) {
    if (values[otherField] === undefined) {
        return false;
    }
    return !(value.length === 0 && values[otherField].length === 0);
});

Formsy.addValidationRule('isAfterDate', function (values, value, otherField) {
    if (values[otherField] === undefined) {
        return false;
    }

    return moment(value, constants.dates.formats.MINIMAL).isSameOrAfter(moment(values[otherField], constants.dates.formats.MINIMAL));
}); 

Formsy.addValidationRule('passwordStrength', (values, value, otherField) => {
    return Number(otherField[0]) >= Number(otherField[1]);
});

Formsy.addValidationRule('tfn', function (values, value) {
    if (value) {
        const trimmedValue = value.replace(/\s+/g, '').replace(/[-]/g, '');

        if (!trimmedValue || trimmedValue.length !== 9) {
            return false;
        }
        
        const weights = [1, 4, 3, 7, 5, 8, 6, 9, 10];
        const checksum = trimmedValue.split('').map(Number).reduce(
            function (total, digit, index) {
                return total + (digit * weights[index]);
            },
            0
        );

        if (!checksum || checksum % 11 !== 0) {
            return false;
        }

        return true;
    } else {
        return true;
    }
});

Formsy.addValidationRule('abn', function (values, value) {
    if (value) {
        const trimmedValue = value.replace(/\s+/g, '');
        if (!trimmedValue || trimmedValue.length !== 11) {
            return false;
        }
        
        const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
        const checksum = trimmedValue.split('').map(Number).reduce(
            function (total, digit, index) {
                if (!index) {
                    digit--;
                }
                return total + (digit * weights[index]);
            },
            0
        );

        if (!checksum || checksum % 89 !== 0) {
            return false;
        }

        return true;
    } else {
        return true;
    }
});

Formsy.addValidationRule('requiredFile', function (values, value) {
    return value === null || value === undefined;
});

Formsy.addValidationRule('greaterThanZero', function (values, value) {
    if (value) {
        if (Number(value) === 'NaN') {
            return false;
        } else {
            return parseFloat(value) > 0;
        }
    } else {
        return true;
    }
});

Formsy.addValidationRule('maxLengthWithoutSpace', (values, value, maxLength) => {
    if (value) {
        const trimmedValue = value.replace(/\s+/g, '');
        if (!trimmedValue || trimmedValue.length > maxLength) {
            return false;
        } else {
            return true;
        }
    } else {
        return true;
    }        
});

Formsy.addValidationRule('timeValidation', (values, value) => {
    if (value !== undefined) {
        if (utils.formatShortTime(value, 15, true)) {
            return true;
        }

        return false;
    }
});

Formsy.addValidationRule('isAfterTime', (values, value, otherField) => {
    if (values[otherField] === undefined) {
        return false;
    }

    var startTime = moment(utils.formatShortTime(values[otherField], null, true), "H:mma");
    var endTime = moment(utils.formatShortTime(value, null, true), "H:mma");
    
    return endTime.isAfter(startTime); 
});